import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";

import Courses from "./Courses";
import Groups from "./Groups";

import { validateAttributes, errorMessage } from "../../utils/validations";
import { validations } from "./validations";
import initials from "../../utils/initials";

const SelectedUser = (props) => {
  const { users, setUsers, selectedUser, allCourses, allGroups } = props;

  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState("");
  const [selectedSetting, setSelectedSetting] = useState("courses");

  useEffect(() => {
    if (selectedUser) {
      setEmail(selectedUser.email);
    }
  }, [selectedUser]);

  const handleEmailChange = async () => {
    if (email === selectedUser.email) return;

    const validation = validateAttributes(
      {
        email,
      },
      validations,
    );

    setErrors(validation);
    if (validation) return;

    const response = await patchUser({ email: email });

    if (response.ok) {
      setErrors({});
      const data = await response.json();

      setUsers(
        users.map((user) => (user.id == selectedUser.id ? data.user : user)),
      );
    } else {
      console.log("error");
    }
  };

  const patchUser = async (params) => {
    return await fetch("/users_management/" + selectedUser.id, {
      method: "PATCH",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
      },
      body: JSON.stringify({
        user: params,
      }),
    });
  };

  const className = (attribute) => {
    let className = "flex-1 bg-gray-100 px-3 py-2";
    if (errors && errors[attribute]) {
      className += " border border-red-500 focus:ring-red-500";
    }
    return className;
  };

  const buttonClassName = (button) => {
    let className = "pl-6 pr-6 pt-3 pb-3";
    if (selectedSetting === button) {
      className += " text-white bg-primaryYellow500";
    } else {
      className += " text-gray-600 hover:text-black";
    }

    return className;
  };

  return (
    <>
      {selectedUser && (
        <div
          className="p-6 bg-white font-sans text-sm text-gray-800 w-3/4"
          style={{ maxWidth: "1000px" }}
        >
          {/* Header */}
          <div className="flex items-center gap-4 mb-6">
            <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center font-semibold">
              {initials(selectedUser.name)}
            </div>
            <h1 className="text-lg font-semibold">{selectedUser.name}</h1>
          </div>

          <div className="space-y-3 mb-6">
            <div className="flex gap-4">
              <span className="w-48 text-gray-500 flex items-center gap-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  strokeWidth="1.5"
                  stroke="currentColor"
                  className="size-6"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M16.5 12a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 1 0-2.636 6.364M16.5 12V8.25"
                  />
                </svg>
                Email
              </span>
              <input
                className={className("email")}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onBlurCapture={handleEmailChange}
              />
            </div>
            {errorMessage(errors, "email")}
          </div>
          <div className="mt-10">
            <div>
              <button
                className={buttonClassName("courses")}
                onClick={() => setSelectedSetting("courses")}
              >
                Szkolenia
              </button>
              <button
                className={buttonClassName("groups")}
                onClick={() => setSelectedSetting("groups")}
              >
                Grupy
              </button>
            </div>

            {selectedSetting == "courses" ? (
              <Courses
                user={selectedUser}
                allCourses={allCourses}
                users={users}
                setUsers={setUsers}
              />
            ) : (
              <Groups
                user={selectedUser}
                allGroups={allGroups}
                users={users}
                setUsers={setUsers}
              />
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default SelectedUser;

SelectedUser.propTypes = {
  selectedUser: PropTypes.object,
  users: PropTypes.array,
  allCourses: PropTypes.array,
  allGroups: PropTypes.array,
  setUsers: PropTypes.func,
};
